"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_dashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4be9a2c5-5572-40e2-821f-0be9652356de",
    "data-name": "dashboard-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "51b132e2-4297-40bb-9465-fe2478e1fa13",
    x1: 112.74,
    y1: 78.36,
    x2: 169.76,
    y2: 135.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "dashboard-hi"), /*#__PURE__*/React.createElement("g", {
    id: "542f4bda-f932-4fbf-9585-0d6e5123a1da",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a6c7b30-152d-4032-9d0e-eff55b0cfc5c",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c893e04e-05eb-4fa0-a7ed-7b93f0f9fb7f",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6b2e7c1-f328-4327-bb79-5c2567a33258",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bf598973-e72f-4e03-84b2-00a5cc944131",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b9de8317-4dae-4765-8d91-80ba6f6e2388",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "634b2eb3-8464-4b57-97ac-f09c952ec1f4",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0304803b-8d7e-429b-864d-73b87995bcf9",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26b1b819-5d26-4bd5-bf53-6b225374d728",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ef840662-5ee4-4046-8608-8dddc38057af",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7a2809c6-856c-4642-861c-f049f61d357e",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4b7d3d5b-03e2-44b3-ac74-4916e5ed8120",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0cff3afd-d4ee-46d5-ab26-befb841c2064",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "026cb07e-05e6-44e5-8208-0af860c94cd1",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4bd4ff23-c67e-40bd-be74-329bec768d94",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46564b5d-7ae4-472c-a63b-a8a0094ee8c2",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1cfcd43c-36ab-4c86-b662-8170ce3206b9",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a88e550-5b24-4f0b-9b93-5eeba26828ee",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a5dd3b58-06e8-4006-9813-601e6eb0b982",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4a90ca1d-991c-4cb1-afa5-e5fb9512f48e",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6cab142b-c76a-4998-96e2-e955d95e4f60",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "72d4d9c4-9144-4a09-8639-6d986678ac68",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57a83ea0-c57b-449f-adf4-915aa68e6734",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3cd931c6-ed5b-4d08-aba7-14eb75c796b9",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "da28914d-6d52-40db-8156-87c88a5a023d",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1005c354-8f10-4bfc-8956-7f3194624009",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9bfa4282-6225-42a5-9b4e-b4996e09e1fb",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5be3e2d9-73cb-4999-8e06-4c436703e732",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,1,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "85ba66a7-db30-467a-8c53-7aebaf6d7dcd",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 35.54,
    x2: 96,
    y2: 52.54,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "12c6e7be-48e4-45a6-ba1e-3064eb5544c0",
    "data-name": "<Pfad>",
    x1: 52.37,
    y1: 96,
    x2: 35.37,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "b0c029de-4da6-43d2-bb82-5c59a865f20a",
    "data-name": "<Pfad>",
    x1: 139.37,
    y1: 95.98,
    x2: 156.37,
    y2: 95.98,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "e2a17dbb-5f81-4ae0-8935-655be5186510",
    "data-name": "<Pfad>",
    x1: 65.11,
    y1: 65.28,
    x2: 53.09,
    y2: 53.26,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,80A16,16,0,1,1,80,96,16,16,0,0,1,96,80m0-2a18,18,0,1,0,18,18A18,18,0,0,0,96,78Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,104,144,160a79.87,79.87,0,0,0,32-64c0-2-.1-4-.24-5.91l-37.38-37Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#51b132e2-4297-40bb-9465-fe2478e1fa13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 12,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("line", {
    id: "01ec2ae4-b599-4f15-bb76-f502dcba4ea0",
    "data-name": "<Pfad>",
    x1: 104.73,
    y1: 87.77,
    x2: 136,
    y2: 56.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,57.48,107.71,88.75a4.22,4.22,0,0,1-.67.54,12,12,0,0,1,.53,1.57l.14-.11L139,59.48a4.19,4.19,0,0,0,1.1-4A4.17,4.17,0,0,1,139,57.48Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,106A12,12,0,0,1,84.05,95c0,.33-.05.66-.05,1a12,12,0,1,0,24,0c0-.34,0-.66-.05-1A12,12,0,0,1,96,106Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))))))));
}

var _default = ic_dashboard;
exports.default = _default;